export default function Spinner({ className = '', ...props }) {
  return <span className={`Spinner ${className}`.trim()} {...props} />;
}

